var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading,"color":"secondary","x-small":"","outlined":""},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Recover")])
}
var staticRenderFns = []

export { render, staticRenderFns }